import { formatError, type FormattedError } from '@shared/utils/RequestUtils';
import { useAuthStore } from '@stores/authStore';
import axios, { AxiosError, AxiosInstance, AxiosResponse } from 'axios';

interface ApiClientOptions {
  baseURL: string;
  headers?: () => Record<string, string>;
  getToken: () => string | null;
  withCredentials?: boolean;
}

const createApiClient = ({ baseURL, headers = () => ({}), getToken }: ApiClientOptions): AxiosInstance => {
  const client = axios.create({
    baseURL,
    headers: {
      'Content-Type': 'application/json',
      ...headers(),
    },
  });

  client.interceptors.request.use((config) => {
    const token = getToken();

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  });

  client.interceptors.response.use(
    (response: AxiosResponse) => {
      return response;
    },
    (error: AxiosError): Promise<FormattedError> => {
      if (error.response?.status === 401) {
        useAuthStore.getState().logout();
      }
      const formattedError = formatError(error);
      return Promise.reject(formattedError);
    },
  );

  return client;
};

export const apiClientWH = createApiClient({
  baseURL: import.meta.env.VITE_API_WH,
  getToken: () => useAuthStore.getState().token,
});
